var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgContainerImage(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 98,
    height: 59,
    viewBox: "0 0 98 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_3128",
    "data-name": "Group 3128",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21421",
    "data-name": "Path 21421",
    d: "M-725.109-333.591l15.01-5.475a3.086,3.086,0,0,0,1.735-2.98v-41.879a3.214,3.214,0,0,0-1.88-3.151L-725.109-392Z",
    transform: "translate(806.364 392.591)",
    fill: "#eae8e8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21422",
    "data-name": "Path 21422",
    d: "M-611.11-389.326l73.751-5.775v59l-73.346-5.277a3.554,3.554,0,0,1-3.492-3.339v-41.636A3.163,3.163,0,0,1-611.11-389.326Zm57.868,38.515a3.205,3.205,0,0,0,3.388,2.985,3.206,3.206,0,0,0,3.39-2.985v-29.582a3.206,3.206,0,0,0-3.39-2.987,3.614,3.614,0,0,0-2.395.875,2.811,2.811,0,0,0-.993,2.112Zm-17.954-1.961a3.205,3.205,0,0,0,3.387,2.987,3.207,3.207,0,0,0,3.391-2.987v-25.742a3.207,3.207,0,0,0-3.391-2.987,3.613,3.613,0,0,0-2.394.875,2.811,2.811,0,0,0-.993,2.112Zm-18.221-1.894a3.208,3.208,0,0,0,3.391,2.984,3.208,3.208,0,0,0,3.391-2.984v-21.9a3.21,3.21,0,0,0-3.391-2.987,3.623,3.623,0,0,0-2.4.875,2.813,2.813,0,0,0-.993,2.112Zm-15.675-1.076a3.205,3.205,0,0,0,3.387,2.987,3.206,3.206,0,0,0,3.39-2.987v-18.913a3.208,3.208,0,0,0-3.39-2.987,3.616,3.616,0,0,0-2.395.875,2.812,2.812,0,0,0-.993,2.112Z",
    transform: "translate(614.197 395.101)",
    fill: "#eae8e8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContainerImage);
export default __webpack_public_path__ + "static/media/ContainerImage.6d37a899c81d9593949552e150d318a6.svg";
export { ForwardRef as ReactComponent };